'use client'

import useTapBalance from '@/utils/hooks/useTapBalance'
import useTapBalanceRest from '@/utils/hooks/useTapBalanceRest'
import { readTapBalanceTransport } from '@/utils/constants'

/**
 * Picks the TAP balance loader from NEXT_PUBLIC_TAP_BALANCE_TRANSPORT.
 * Default: `'rest'` — uses our in-house tap-reader. Set the env value to
 * `'ws'` before a rebuild for an emergency fallback to legacy tap.trac.network.
 *
 * Both hooks are always called to keep hook order stable; the inactive
 * one is gated by passing an empty address so it does no network work.
 */
export default function useTapBalanceUnified(address: string) {
	const transport = readTapBalanceTransport()
	const ws = useTapBalance(transport === 'ws' ? address : '')
	const rest = useTapBalanceRest(transport === 'ws' ? '' : address)
	return transport === 'ws' ? ws : rest
}
